import React, { memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col, Input, Form, Button } from 'antd'
import { useMutation } from '@apollo/react-hooks'
import { toast } from 'react-toastify'

import classes from './styles.module.scss'
import { StoreValue, SendQRCode as ResendQRCodeMutation } from 'store'

const ResendQRCode: React.FunctionComponent<any> = ({ handleResendQRCode }) => {
	const { i18n } = useTranslation()
	const t = i18n.getFixedT('ro')

	const [resendQRCodeMutation] = useMutation(ResendQRCodeMutation)

	const onFinish = useCallback(
		async (values: { email: string }) => {
			await resendQRCodeMutation({
				variables: {
					language: i18n.language,
					email: values.email,
				},
			})
				.then(
					(response: { data?: { sendQRCode: { code: string } } }) => {
						if (response?.data?.sendQRCode?.code !== '404') {
							handleResendQRCode()
						} else {
							toast.error(
								t(
									`We couldn't find the email. Please register.`,
								),
								{
									position: 'top-center',
									autoClose: 5000,
									hideProgressBar: false,
									closeOnClick: true,
									pauseOnHover: true,
									draggable: true,
								},
							)
						}
					},
				)
				.catch(() => {
					toast.error(
						t(`We couldn't find the email. Please register.`),
						{
							position: 'top-center',
							autoClose: 5000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
						},
					)
				})
		},
		[resendQRCodeMutation, handleResendQRCode, i18n.language, t],
	)

	return (
		<Form
			name="student_kit_recover_qr_code"
			initialValues={{ remember: true }}
			onFinish={onFinish}
		>
			<div className={classes.container}>
				<Row className={classes.row} gutter={8}>
					<Col
						className={classes.column}
						sm={{ span: 24 }}
						md={{ span: 12 }}
					>
						<Form.Item
							name="email"
							rules={[
								{
									type: 'email',
									required: true,
									message: t('Please enter your email'),
								},
							]}
						>
							<Input
								id="email"
								type={'text'}
								placeholder={t('Email')}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row className={classes.row}>
					<Col
						className={classes.column}
						sm={{ span: 4 }}
						md={{ span: 2 }}
					>
						<div className={classes.saveButton}>
							<Button htmlType={'submit'} type="primary">
								{t('Send')}
							</Button>
						</div>
					</Col>
				</Row>
			</div>
		</Form>
	)
}

export default memo((props: any) => (
	<StoreValue keys={['user|storeUser']}>
		<ResendQRCode {...props} />
	</StoreValue>
))
